import * as React from "react";
import type { SVGProps } from "react";
const SvgPersonOnSnowboardInRamp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.488 6.653a2.163 2.163 0 0 0 1.053.18.997.997 0 0 0-.241.647v2.36c0 .25-.17.38-.24.42a.44.44 0 0 1-.48 0l-.12-.07a1.007 1.007 0 0 0-.117-.061 1.01 1.01 0 0 0-.423-1.389l-1.89-.95a.998.998 0 0 0-1.25.3l-1.453 1.96L7.28 9c-.19-.19-.31-.42-.36-.7-.1-.54-.62-.91-1.16-.81-.54.1-.9.62-.81 1.16.12.68.43 1.29.91 1.77l5.79 5.8c.46.47 1.18.87 1.83 1.02.08.03.15.03.23.03l.01-.01c.45 0 .86-.31.97-.77a1.01 1.01 0 0 0-.75-1.2c-.28-.07-.68-.29-.88-.49l-.855-.858 1.115-1.672a2.4 2.4 0 0 0 1.73-.27c.79-.45 1.26-1.25 1.26-2.16v-1.1l.96.22c.33.07.69-.03.93-.27l1.5-1.5a.996.996 0 1 0-1.41-1.41l-1.11 1.11-1.65-.38-.007-.002A2.183 2.183 0 0 0 16.55 4.66v-.47c0-1.2-.98-2.18-2.18-2.18-1.2 0-2.18.98-2.18 2.18v.47c0 .297.06.581.169.84H11.16l-1.35-.45a.992.992 0 0 0-1.26.63c-.18.53.11 1.1.63 1.27l1.5.5c.11.03.21.05.32.05h1.5c.498 0 .914-.369.988-.847Zm.702-2.473c0-.1.08-.18.18-.18h.01c.1 0 .18.08.18.18v.47c0 .2-.37.2-.37 0v-.47Zm-2.16 6.35.04.019-1.3 1.954-1.01-1.014 1.13-1.529 1.14.57Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M20 21c0 .55.45 1 1 1s1-.45 1-1v-8c0-.55-.45-1-1-1h-2c-.55 0-1 .45-1 1 0 3.42-2.58 6-6 6s-6-2.58-6-6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1s1-.45 1-1v-7h.06c.46 4.05 3.72 7 7.94 7 4.22 0 7.48-2.95 7.94-7H20v7Z"
    />
  </svg>
);
export default SvgPersonOnSnowboardInRamp;
